<template>
    <div
        v-if="isOnboardingComplete"
        class="widget integrations-widget"
    >
        <header class="widget-header">
            <p class="title">
                Platforms
            </p>
            <router-link
                :to="'/platforms/'"
                class="arrow-link"
            >
                See all platforms <i class="far fa-long-arrow-right" />
            </router-link>
        </header>
        <div class="widget-body">
            <integration
                v-for="integration in integrations"
                :key="integration.name"
                :integration="integration"
            />
        </div>
    </div>
</template>

<script>
import integrationsConfig from '@/utils/config/integrations';
import Integration from '@/components/Integrations/Integration';

const integrations = integrationsConfig.integrationsArray;

export default {
    components: {
        Integration,
    },

    props: {
        isOnboardingComplete: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        integrations,
    }),
};
</script>
